import(/* webpackMode: "eager" */ "/data01/virt128836/domeenid/www.kursused.ebs.ee/kursused/src/app/(frontend)/not-found.tsx");
